export const REQUEST_HERO = 'concrete/REQUEST_HERO'
export const RECEIVE_HERO = 'concrete/RECEIVE_HERO'
export const ERROR_HERO = 'concrete/ERROR_HERO'



// WEBPACK FOOTER //
// ./src/components/hero/action-types.js